/* Demo Stats page — mirrors the real StatsPage layout with tabs,
   using AnalyticsVariantA with mock data. No Convex dependencies. */

import { ScrollArea } from "@/components/ui/scroll-area";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { AnalyticsVariantA } from "@/components/analytics/AnalyticsVariantA";
import { MOCK_ANALYTICS } from "@/components/analytics/analyticsFixtures";
import { BarChart3, History } from "lucide-react";

function CompletedEmptyState() {
  return (
    <div className="flex flex-col items-center justify-center py-16 gap-4 text-center px-4">
      <BarChart3 className="size-12 text-muted-foreground/50" />
      <div>
        <h2 className="text-lg font-semibold">No completed items yet</h2>
        <p className="text-sm text-muted-foreground mt-1">
          Complete some items from your queue to see them here.
        </p>
      </div>
    </div>
  );
}

function HistoryEmptyState() {
  return (
    <div className="flex flex-col items-center justify-center py-16 gap-4 text-center px-4">
      <History className="size-12 text-muted-foreground/50" />
      <div>
        <h2 className="text-lg font-semibold">No update history</h2>
        <p className="text-sm text-muted-foreground mt-1">
          Feed update history will appear here after your sources are refreshed.
        </p>
      </div>
    </div>
  );
}

export function DemoStatsPage() {
  return (
    <ScrollArea className="h-full">
      <div className="px-4 md:px-6 pt-4 md:pt-6">
        <div className="sticky top-0 z-20 bg-background pb-2">
          <h1 className="text-2xl md:text-3xl font-bold tracking-tight">
            Stats
          </h1>
        </div>

        <Tabs defaultValue="overview">
          <TabsList>
            <TabsTrigger value="overview">Overview</TabsTrigger>
            <TabsTrigger value="completed">Completed</TabsTrigger>
            <TabsTrigger value="history">Feed History</TabsTrigger>
          </TabsList>

          <TabsContent value="overview">
            <AnalyticsVariantA data={MOCK_ANALYTICS} hideKiwiCollection />
          </TabsContent>

          <TabsContent value="completed">
            <CompletedEmptyState />
          </TabsContent>

          <TabsContent value="history">
            <HistoryEmptyState />
          </TabsContent>
        </Tabs>
      </div>
    </ScrollArea>
  );
}
